import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { PlainMarkdown } from '@gitbook/react-uikit';

import { resolveDynamicBinding } from './bindings';
import type { ContentKitElementProps } from './types';

export function ContentKitMarkdown(
    props: ContentKitElementProps<api.ContentKitMarkdown>
): React.ReactElement {
    const { element, localState } = props;

    return (
        <React.Suspense fallback={null}>
            <PlainMarkdown input={resolveDynamicBinding(localState, element.content)} />
        </React.Suspense>
    );
}
